export const termsAndConditions = [
  {
    id: '01',
    title: 'Cómo funciona la reserva',
    content: 'reservation-info'
  },
  {
    id: '02',
    title: 'Qué pasa después de la reserva',
    content: 'reservation-terms'
  },
  {
    id: '03',
    title: 'Pueden rechazar mi reserva',
    content: 'reservation-can-reject'
  },
  {
    id: '04',
    title: 'Cómo recupero mi dinero',
    content: 'reservation-how-to-recover-money'
  },
  {
    id: '05',
    title: 'Cuál es mi responsabilidad',
    content: 'reservation-user-responsibility'
  },
  {
    id: '06',
    title: 'Aspectos a tener en cuenta',
    content: 'reservation-important-aspects'
  },
  {
    id: '07',
    title: 'Consulta las condiciones legales',
    content: 'reservation-legal-conditions-link'
  }
]

export const defaultStateOpenTermsTabs = {
  '01': false,
  '02': false,
  '03': false,
  '04': false,
  '05': false,
  '06': false,
  '07': false
}

export const RESERVATION_EVENTS_TRACKING = {
  RESERVATION_INFORMATION_CLICKED: 'Reservation Information Clicked',
  RESERVATION_START_CLICKED: 'Reservation Start Clicked',
  RESERVATION_MORE_INFORMATION_CLICKED: 'Reservation More Information Clicked',
  RESERVATION_MANAGE_CLICKED: 'Reservation Manage Clicked',
  RESERVATION_MODAL_CLOSED: 'Reservation Faq Modal Closed',
  RESERVATION_DRAWER_VIEWED: 'Reservation Drawer Viewed'
}

export const RESERVATION_DRAWER_PAGE_NAME = 'drawer reserva'

export const CONTENT_TYPE = {
  RESERVATION_INFO: 'reservationInfo',
  RESERVATION_TERMS: 'reservationTerms',
  RESERVATION_LEGAL_CONDITIONS: 'reservationLegalConditions'
}
